import { useTranslation } from '@dreamstack/i18n'
import { SimpleModal } from '@dreamstack/simple-components/src/lib/SimpleModal'
import type { FunctionComponent } from 'react'
import { useState } from 'react'
import { Button } from '../layout/Button'

export const ConfirmationDialog: FunctionComponent<
  React.PropsWithChildren<{
    title?: string
    text: string
    confirmationText?: string
    callback?: CallableFunction
    open: boolean
    onHandleClose: CallableFunction
    deleteConfirmation?: boolean
    deleteConfirmationText?: string
  }>
> = ({
  title,
  text,
  callback,
  open,
  onHandleClose,
  confirmationText,
  deleteConfirmation,
  deleteConfirmationText,
}) => {
  const t = useTranslation()
  const [loading, setLoading] = useState(false)
  return (
    <SimpleModal
      open={open}
      handleClose={() => onHandleClose()}
      title={title ?? ''}
      intro={text}
    >
      <div className="mb-0">
        <div className="flex gap-px-16 flex-row flex-wrap">
          {!!deleteConfirmation ? (
            <Button
              variant="contained"
              color="warn"
              disabled={loading}
              onClick={async () => {
                setLoading(true)
                if (callback) await callback()
                onHandleClose()
                setLoading(false)
              }}
              loading={loading}
            >
              {deleteConfirmationText || t('accentro:delete')}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              disabled={loading}
              loading={loading}
              onClick={async () => {
                setLoading(true)
                if (callback) await callback()
                onHandleClose()
                setLoading(false)
              }}
            >
              {confirmationText || t('accentro:confirm')}
            </Button>
          )}

          {!loading && (
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => onHandleClose()}
            >
              {t('accentro:cancel')}
            </Button>
          )}
        </div>
      </div>
    </SimpleModal>
  )
}
